// extracted by mini-css-extract-plugin
export default {"loader__container":"styles_loader__container__Vfg+h","overlay":"styles_overlay__+49ld","loader__text":"styles_loader__text__AMBGS","loader__box":"styles_loader__box__aMrt2"};